// The bridge to the apps. Each app puts a small handler in the web view:
// on iOS a WKScriptMessageHandler named "substance", on Android a
// JavascriptInterface named "SubstanceAndroid". Web code speaks to whichever is
// there through window.SubstanceNative, and the apps call back through
// window.SubstanceNative.receive (a push token, say). In a plain browser
// nothing is available and nothing is sent.
const ios = () => window.webkit?.messageHandlers?.substance
const android = () => window.SubstanceAndroid

function send(name, data = {}) {
  const message = { name, ...data }
  if (ios()) {
    ios().postMessage(message)
  } else if (android()) {
    android().postMessage(JSON.stringify(message))
  }
}

async function post(path, body) {
  const csrf = document.querySelector("meta[name='csrf-token']")?.content ?? ""
  return fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf, Accept: "application/json" },
    body: JSON.stringify(body)
  })
}

async function register(platform, token) {
  try {
    await post("/devices", { platform, token })
  } catch { /* offline; the app will offer the token again next launch */ }
}

// A moment the app saw and the server did not - brought back to the front,
// say - noted for the platform's ledger. Only for a signed-in member.
async function note(name) {
  if (document.body.dataset.member !== "true") return
  try {
    await post("/events", { name })
  } catch { /* nothing lost worth keeping */ }
}

window.SubstanceNative = {
  get available() { return Boolean(ios() || android()) },

  // A touch back from the phone: "light", "medium", or "success".
  haptic(style = "light") { send("haptic", { style }) },

  // The app asks whether this page's member wants notifications on this phone.
  // Answered by the app with receive({ name: "pushToken", platform, token }).
  requestPushToken() { send("requestPushToken") },

  // Messages from the app: a push token; the app brought back to the front.
  receive(message) {
    if (typeof message === "string") message = JSON.parse(message)
    if (message.name === "pushToken" && message.token) register(message.platform, message.token)
    if (message.name === "appOpened") note("app_opened")
  }
}

// Once a member is signed in on a phone, ask the app for its push token; the
// app decides whether to ask the member for permission, and when.
document.addEventListener("turbo:load", () => {
  if (window.SubstanceNative.available && document.body.dataset.member === "true") {
    window.SubstanceNative.requestPushToken()
  }
})
